$(document).ready(function () {

  initURLTarget(); // Initialise les data target cliquables
  initReassuranceCarousel(); // Initialisation du carrousel de réassurance
  initEditoColonnesCarousel(); // Initialisation du carrousel edito-colonnes
  initMegaMenuHeightSync(); // Synchronisation des hauteurs du mega menu
  initStickyBasket(); // Initialisation du sticky basket
  initCartHelp(); // Initialisation du toggle cart help
  initNewsletter();

});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
}

// Initialisation de la newsletter
function initNewsletter() {
  // Si la popin existe, on doit pouvoir la fermer
  if ($("#newsletter_popin").length > 0) {
    // Au click sur le bouton de fermeture
    $(document).on("click", ".newsletter_popin_close", function () {
      closeNewsletter();
    });
  }

  // Vérifie s'il faut afficher la popin
  checkNewsletter();
}

// Custom Element pour Card-product
class CardProduct extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector('.swiper');
    this.productCard = this.querySelector('.product_item');
  }
  connectedCallback() {
    this.initSwipers(); // Initialisation des swiper de cartes produits
  }

  initSwipers() {

    let swiper = new Swiper(this.swiper, {
      direction: 'horizontal',
      loop: true,
      speed: 300,
      effect: 'fade', // Par défaut "slide" sur mobile
      fadeEffect: {
        crossFade: true
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        enabled: true,
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar')
      }
    });

    // Ajout de l'effet hover sur la carte produit
    if (this.productCard) {
      // Supprimer les anciens event listeners s'ils existent pour éviter les doublons
      this.productCard.removeEventListener('mouseenter', this.productCard._swiperMouseEnter);
      this.productCard.removeEventListener('mouseleave', this.productCard._swiperMouseLeave);

      // Créer les nouvelles fonctions et les stocker sur l'élément
      this.productCard._swiperMouseEnter = () => swiper.slideTo(1);
      this.productCard._swiperMouseLeave = () => swiper.slideTo(0);

      this.productCard.addEventListener('mouseenter', this.productCard._swiperMouseEnter);
      this.productCard.addEventListener('mouseleave', this.productCard._swiperMouseLeave);
    }
  }
}
customElements.define('card-product', CardProduct);



/***********************************************************************************/
// Gestion du sticky basket en PDP mobile

function initStickyBasket() {
  // Gestion du clic sur le bouton sticky
  $(".sticky_button")
    .off("click.stickyBasket")
    .on("click.stickyBasket", function () {
      const productInfoWrapper = $(".product__info-wrapper");
      const wrapperOffsetTop = productInfoWrapper.offset().top;
      const wrapperHeight = productInfoWrapper.outerHeight();
      const viewportHeight = $(window).height();

      $([document.documentElement, document.body]).animate(
        {
          scrollTop: wrapperOffsetTop + wrapperHeight - viewportHeight - 80,
        },
        400
      );
    });
  // Variables globales pour le sticky basket
  const add_to_cart_buttons = $(".product-form__buttons");
  const sticky_basket = $("#sticky_basket");

  function checkStickyBasketVisibility() {
    if (add_to_cart_buttons.length === 0) {
      return;
    }

    const addToCartTop = add_to_cart_buttons.offset().top;
    const addToCartBottom = addToCartTop + add_to_cart_buttons.outerHeight();
    const scrollTop = $(window).scrollTop();
    const viewportHeight = $(window).height();

    // being sure to restrain this behavior to mobile devices
    if ($(window).width() < 1023) {
      // Si on a dépassé complètement les boutons d'ajout au panier, on cache le sticky basket
      if (scrollTop + viewportHeight > addToCartBottom) {
        sticky_basket.slideUp(150);
      } else {
        sticky_basket.slideDown(150);
      }
    }
  }

  checkStickyBasketVisibility(); // Vérifier la visibilité au chargement de la page

  // Vérifier la visibilité au défilement
  $(document)
    .off("scroll.stickyBasket")
    .on("scroll.stickyBasket", function () {
      checkStickyBasketVisibility();
    });
}

// Fonction pour vérifier si un élément est visible dans la fenêtre
function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}

// Initialisation du carrousel de réassurance
function initReassuranceCarousel() {
  $('.reassurance_pdp').each(function () {
    const $container = $(this);
    const $slider = $container.find('.reassurance_pdp__slider');
    const $slides = $slider.find('.reassurance_pdp__slide');
    const $indicators = $container.find('.reassurance_pdp__indicator');

    // Vérifier s'il y a plus d'une slide
    if ($slides.length <= 1) {
      return;
    }

    let currentSlide = 0;
    let autoPlayInterval;

    // Fonction pour changer de slide
    function goToSlide(index) {
      // Masquer toutes les slides
      $slides.hide();

      // Afficher la slide sélectionnée
      $slides.eq(index).show();

      // Mettre à jour les indicateurs
      $indicators.removeClass('reassurance_pdp__indicator--active');
      $indicators.eq(index).addClass('reassurance_pdp__indicator--active');

      currentSlide = index;
    }

    // Fonction pour passer à la slide suivante
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % $slides.length;
      goToSlide(nextIndex);
    }

    // Fonction pour démarrer le défilement automatique
    function startAutoPlay() {
      autoPlayInterval = setInterval(nextSlide, 3000); // 3 secondes
    }

    // Fonction pour arrêter le défilement automatique
    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
      }
    }

    // Gestion des clics sur les indicateurs
    $indicators.on('click', function () {
      const slideIndex = $(this).data('slide');
      goToSlide(slideIndex);

      // Redémarrer le défilement automatique après un clic manuel
      stopAutoPlay();
      startAutoPlay();
    });

    // Pause du défilement automatique au survol
    $container.on('mouseenter', stopAutoPlay);
    $container.on('mouseleave', startAutoPlay);

    // Démarrer le défilement automatique
    startAutoPlay();
  });
}

// Initialisation des carousels Edito Colonnes
function initEditoColonnesCarousel() {
  document.querySelectorAll('.swiper_edito_colonnes').forEach((swiperEl) => {

    // Récupération de la valeur CSS --blocks-gap définie dans les settings
    const sectionElement = swiperEl.closest('[class*="section-"][class*="-spacing"]');
    const computedStyle = getComputedStyle(sectionElement);
    const spaceBetween = parseInt(computedStyle.getPropertyValue('--blocks-gap')) || 24;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,
      centeredSlides: true,
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      resizeObserver: true,
      // Carousel infini
      loop: true,
      loopAdditionalSlides: 0,
      // Gestion du glissement tactile/souris
      allowTouchMove: true,
      simulateTouch: true,
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      // Plus besoin de breakpoints: la variable CSS --blocks-gap gère déjà le responsive
      on: {
        init: (swiper) => {
          // Nettoie les margins CSS maintenant que Swiper gère l'espacement
          swiper.slides.forEach(slide => {
            slide.style.marginRight = '';
          });
        },
        resize: () => {
          // Recalcul du spacing au resize depuis la variable CSS
          const sectionElement = swiperEl.closest('[class*="section-"][class*="-spacing"]');
          const computedStyle = getComputedStyle(sectionElement);
          const newSpaceBetween = parseInt(computedStyle.getPropertyValue('--blocks-gap')) || 24;
          swiper.params.spaceBetween = newSpaceBetween;
          swiper.update();
        }
      },
    });
  });
}

// Synchronisation des hauteurs du mega menu
function initMegaMenuHeightSync() {

  // Fonction pour ajuster la hauteur du container d'images
  function adjustPushImageHeight() {
    document.querySelectorAll('.mega-menu__columns').forEach((columnsContainer) => {
      const pushImageContainer = columnsContainer.querySelector('.mega-menu__push-image-container');

      if (pushImageContainer) {
        // Réinitialiser la hauteur pour calculer la hauteur naturelle
        pushImageContainer.style.height = 'auto';

        // Calculer la hauteur des colonnes
        const columnsHeight = columnsContainer.offsetHeight;

        // Appliquer cette hauteur au container d'images
        pushImageContainer.style.height = columnsHeight + 'px';
      }
    });
  }

  // Écouter l'ouverture des mega menus
  document.querySelectorAll('.mega-menu details').forEach((details) => {
    details.addEventListener('toggle', function () {
      if (this.open) {
        // Attendre que l'animation soit terminée
        setTimeout(adjustPushImageHeight, 50);
      }
    });
  });

  // Écouter les changements de taille de fenêtre
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Seulement si un mega menu est ouvert
      const openMegaMenu = document.querySelector('.mega-menu[open]');
      if (openMegaMenu) {
        adjustPushImageHeight();
      }
    }, 150);
  });

  // Ajuster au chargement si un mega menu est déjà ouvert
  setTimeout(adjustPushImageHeight, 100);
}

// Initialisation du toggle cart help
function initCartHelp() {
  $('.cart_help__header').off('click.cartHelp').on('click.cartHelp', function() {
    const $cartHelp = $(this).closest('.cart_help');
    const $content = $cartHelp.find('.cart_help__content');

    $cartHelp.toggleClass('cart_help--open');
    $content.slideToggle(200);
  });
}


// Fermeture de la popin newsletter
function closeNewsletter() {
  $("#newsletter_popin").hide();
  $('body').css({ overflow: 'auto' });

  // Si on ferme la popin, on créé un cookie pour ne plus l'afficher
  var date = new Date();
  localStorage.setItem('pr_nl_popin', date);
}

// Ouverture de la popin newsletter
function openNewsletter(speed) {
  var delay = 1;
  delay = $("#newsletter_popin").attr("data-delay") * 1000;

  if (speed == "fast") {
    delay = 0;
  }

  $("#newsletter_popin").delay(delay).fadeIn(200, function () {
    $('body').css({ overflow: 'hidden' });
  });
}

// Affichage de la popin newsletter
function checkNewsletter() {
  var date = new Date();
  var url = window.location.href;
  openNewsletter("fast");

  /*
  // if url contains ?customer_posted=true, open newsletter
  if (url.indexOf("?customer_posted=true") !== -1) {
    openNewsletter("fast");
    // Puis on créé un cookie pour ne plus afficher la popin
    localStorage.setItem('pr_nl_popin', date);
  }
  else {

    // Si on n'est pas sur la page de Challenge Captcha
    if (url.indexOf("challenge") !== -1) {
      return false;
    }
    else {

      // Si première visite, on créé un cookie
      if (localStorage.getItem('pr_nl_popin') == null || localStorage.getItem('pr_nl_popin') == "undefined") {
        openNewsletter();
      }
      // Si déjà visité, on checke la date de dernière visite
      else {
        var check_time = new Date(date) - new Date(localStorage.getItem('pr_nl_popin'));
        var ms = check_time % 1000;
        check_time = (check_time - ms) / 1000;
        var days = Math.floor(check_time / 86400);

        // Si dernière visite il y a plus de 10 jours
        if (days > 10) {
          localStorage.setItem('pr_nl_popin', date);
          openNewsletter();
        }
      }
    }
  }
  */
}
